import *as TYPES from '../action-types';
let language = {
    changeLanguage(){
        return {type:TYPES.CHANGE_LANGUAGE}
    }
};
export default language;


// WEBPACK FOOTER //
// ./src/store/actions/Language.js